import React, { useState } from "react";
import ScoreMemberCard from "../ScoreItem/ScoreMemberCard";
import { IRecipientModel } from "../../../../Models/Recipient";
import ModuleOverviewModal from "../../../../Pages/PartnerModules/ModuleOverviewModal";
import TaskList from "../../../Assessment/TaskList/TaskList";
import TaskModal from "../ModuleTasks/ModuleModal/TaskModal";
import SpiritualModuleDescription from "../../../../Pages/PartnerModules/SpiritualModuleDescription";
import ChurchIcon from "../../../../Images/Icons/Church Icon.png";
import { observer } from "mobx-react-lite";
import { moduleTitles } from "../../../Enums/TitleEnums"

export interface ISpiritualScoreCardProps {
  selectedRecipient: IRecipientModel;
  caregiverId: string;
}
const SpiritualScoreCard: React.FC<ISpiritualScoreCardProps> = ({
  selectedRecipient, caregiverId
}) => {
  const [moduleOverviewVisible, setModuleOverviewVisible] = useState(false);
  const [taskAssessmentVisible, setTaskAssessmentVisible] = useState(false);
  const [taskChecklistVisible, setTaskChecklistVisible] = useState(false);
  const [taskIndex, setTaskIndex] = useState(0);
  const [taskTitle, setTaskTitle] = useState(selectedRecipient.spiritualAssessment.questions[0].taskName || "");

  const setOverviewVisible = () => { setModuleOverviewVisible(true); };
  const setIndexOfTask = (idx: number) => { setTaskIndex(idx); };
  const setTitleOfTask = (title: string) => { setTaskTitle(title); };

  const questions = selectedRecipient.spiritualAssessment.questions;
  const renderModuleOverview = () => {
    return (
      <ModuleOverviewModal
        overviewBody={<SpiritualModuleDescription />}
        hideOverview={() => setModuleOverviewVisible(false)}
        tasks={questions}
        assessment={selectedRecipient.spiritualAssessment}
        domain={moduleTitles.SPIRITUAL}
        taskIndex={taskIndex}
        caregiverId={caregiverId}
        selectedRecipientId={selectedRecipient.id}
        selectedRecipientName={`${selectedRecipient.firstName} ${selectedRecipient.lastName}`}
        setTaskChecklistToVisible={() => setTaskChecklistVisible(true)}
        setAssessmentToVisible={() => setTaskAssessmentVisible(true)}
        setAssessmentHidden={() => setTaskAssessmentVisible(false)}
        setTaskIndex={setIndexOfTask}
        setTaskTitle={setTitleOfTask}
      />
    );
  };

  const renderTaskModal = () => {
    return (
      <TaskModal
        hideAssessment={() => setTaskAssessmentVisible(false)}
        taskIndex={taskIndex}
        taskTitle={taskTitle}
        recipient={selectedRecipient}
        assessment={selectedRecipient.spiritualAssessment}
        caregiverId={caregiverId}
        selectedRecipientId={selectedRecipient.id}
        selectedRecipientName={`${selectedRecipient.firstName} ${selectedRecipient.lastName}`}
        domain={moduleTitles.SPIRITUAL}
        setTaskTitle={setTitleOfTask}
      />
    );
  };

  const renderTaskChecklistModal = () => {
    return (
      <TaskList
        assessment={selectedRecipient.spiritualAssessment}
        hideTaskList={() => setTaskChecklistVisible(false)}
      />
    );
  };

  return (
    <>
      {taskChecklistVisible && renderTaskChecklistModal()}
      {taskAssessmentVisible && renderTaskModal()}
      {moduleOverviewVisible && renderModuleOverview()}
      <ScoreMemberCard
        percentComplete={selectedRecipient.spiritualScoreComplete}
        selectedRecipient={selectedRecipient}
        icon={ChurchIcon}
        title={moduleTitles.SPIRITUAL}
        overviewTitle="Spiritual/Emotional Domain"
        videoLink={"undefined"}
        overviewBody={<SpiritualModuleDescription />}
        assessment={selectedRecipient.spiritualAssessment}
        tasks={[]}
        setAssessmentVisible={setOverviewVisible}
        setModVisible={setOverviewVisible}
      />
    </>
  );
};

export default observer(SpiritualScoreCard);
